export default "__VITE_ASSET__DdVVU4Bu__"